module.exports = "/_next/static/images/OnboardingMobile-41a0dabbe09b3ca9c166ced8324f447c.webp";